module.exports = __webpack_public_path__ + "media/images/features/6/schedule-8-8d1f7f9e4b9fe065b381657752ecc839.png";